import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { DatabaseService } from 'src/app/core/services/base/database.service';
import { environment } from 'src/environments/environment';

export interface SignedContract {
  id: string;
  url: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class OaSignatureService extends DatabaseService<SignedContract> {
  constructor(private http: HttpClient) {
    super('cp_signed_contract');
  }

  /**
   * Busca assinatura do usuário considerando versões anteriores do contrato
   * Se contractId for fornecido, verifica contrato atual + versões anteriores
   */
  async getAllGroupedByCase(
    claimId: string,
    contractId?: string
  ): Promise<SignedContract | undefined> {
    let contractIdsToCheck: string[] = [];

    // Se contractId for fornecido, busca versões anteriores
    if (contractId) {
      contractIdsToCheck = [contractId];

      // Busca o contrato e suas versões anteriores
      const { data: contractData } = await this.supabase
        .from('cp_contract')
        .select('id, attributes')
        .eq('id', contractId)
        .maybeSingle() as any;

      if (contractData?.attributes?.previous_versions && Array.isArray(contractData.attributes.previous_versions)) {
        contractIdsToCheck.push(...contractData.attributes.previous_versions);
        console.log('[OA_SIGNATURE_SERVICE] Contract has previous versions', {
          currentContractId: contractId,
          previousVersions: contractData.attributes.previous_versions,
          totalToCheck: contractIdsToCheck.length,
        });
      }
    }

    // Monta query base
    let query = this.supabase
      .from(this.table)
      .select()
      .eq('status', 'SIGNED')
      .eq('claim_id', claimId);

    // Se tem contractIds para verificar, filtra por eles
    if (contractIdsToCheck.length > 0) {
      query = query.in('contract_id', contractIdsToCheck);
    }

    // Ordena pela mais recente
    query = query.order('created_at', { ascending: false }).limit(1);

    const { data, error } = await query;

    if (error) throw new Error(error.message);

    if (data && data.length > 0) {
      console.log('[OA_SIGNATURE_SERVICE] Found signature', {
        signedContractId: data[0].id,
        contractId: (data[0] as any).contract_id,
        isFromPreviousVersion: contractId && (data[0] as any).contract_id !== contractId,
      });
    }

    return data?.[0];
  }

  async retract(id: string) {
    const token = (await this.supabase.auth.getSession()).data.session
      ?.access_token;

    const ret = (await firstValueFrom(
      this.http.put(
        environment.lambdaUrl + '/retract_signature',
        { signed_contract_id: id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
    )) as any;

    return ret;
  }
}
